import { useQuery } from '@tanstack/react-query';

// helper
import { BaseError } from './../../helpers/BaseError';

// models
import { DatasetListModel } from '../../models/dataset.model';

// services
import API from '../../services/api';

const getDatasets = async (): Promise<DatasetListModel[]> => {
    const { data } = await API.fetchDatasets();
    return data?.items ?? [];
};

export default function useDatasetsQuery() {
    return useQuery<DatasetListModel[], BaseError>({
        queryKey: ['datasets'],
        queryFn: () => getDatasets(),

        staleTime: 1000 * 24 * 60 * 60,
    });
}
